import React, { Component } from "react"
import Dialog from "react-toolbox/lib/dialog"
import Division from "../../components/Division"
import * as strings from "../../strings"
import { Formik, Form } from "formik"
import _ from "lodash"


class FormikDialog extends Component {
  props: {
    title: string,

    yupSchema: {},
    initialValues: {},

    onSave: ( mixed ) => any,
    onDelete: ( mixed ) => any,
    onCancel: ( mixed ) => any,
    extraActions: ?{},

    visible: boolean,
    children: [],
    dialogType: ?string,
    dialogClassName: ?string,
  }

  submit = ( values, formik ) => {
    if ( this.props.onSave ) {
      this.props.onSave( values )
    }
    formik.resetForm()
  }

  _delete = formik => () => {
    if ( this.props.onDelete ) {
      this.props.onDelete( formik.values )
    }
    formik.resetForm()
  }

  cancel = formik => () => {
    if ( this.props.onCancel ) {
      this.props.onCancel( formik.values )
    }

    formik.resetForm()
  }

  buildActions = formik => {
    let actions = []

    if ( this.props.extraActions ) {
      _.keys( this.props.extraActions ).forEach( name => {
        const actionFn = this.props.extraActions[ name ]
        actions.push( {
          label: name,
          onClick: actionFn.bind( null, formik ),
        } )
      } )
    }

    if ( this.props.onCancel ) {
      actions.push( {
        label: strings.generalStrings.cancel,
        onClick: this.cancel( formik ),
      } )
    }

    if ( this.props.onDelete ) {
      actions.push( {
        label: strings.generalStrings.delete,
        onClick: this._delete( formik ),
      } )
    }

    if ( this.props.onSave ) {
      actions.push( {
        label: strings.generalStrings.keep,
        onClick: formik.submitForm,
      } )
    }

    return actions
  }

  render () {
    return (
      <Formik
        initialValues={this.props.initialValues}
        validationSchema={this.props.yupSchema}
        onSubmit={this.submit}
        enableReinitialize
      >
        { ( ...formikRenderArgs ) => {
          const formik = formikRenderArgs[ 0 ]
          return (
            <Dialog
              actions={this.buildActions( formik )}
              active={this.props.visible}
              onEscKeyDown={this.cancel( formik )}
              onOverlayClick={this.cancel( formik )}
              type={this.props.dialogType}
              className={this.props.dialogClassName}
            >
              <Division title={this.props.title} />
              <Form>
                {this.props.children.apply
                  ? this.props.children( ...formikRenderArgs )
                  : this.props.children}
              </Form>
            </Dialog>
          )
        }}
      </Formik>
    )
  }
}

export default FormikDialog



// WEBPACK FOOTER //
// ./src/components/FormikDialog/index.jsx